<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><span class="bold">Praise for</span></h2>
<h2 class="fm-title1"><em class="italic"><span class="bold">Dark Lie</span></em></h2>
<p class="noindent">“Nancy Springer’s first foray into suspense is a darkly riveting read, featuring a scarred heroine whose past is shrouded in a shameful secret she would kill—or die—to protect. The pages swiftly fall away, along with layers of secrets and lies, to reveal the pulsing heart of this compelling thriller: the primal bonds between parent and child, between man and woman—and the fine line between love and hate.”</p>
<p class="right">—Wendy Corsi Staub, national bestselling author of <em class="italic">Nightwatcher</em> and <em class="italic">Sleepwalker</em></p>
<p class="noindent">“A fast-paced, edge-of-your-seat thriller that will have you reading late into the night and cheering for the novel’s unlikely but steadfast heroine, Dorrie White.”</p>
<p class="right">—Heather Gudenkauf, <em class="italic">New York Times</em> bestselling author of <em class="italic">The Weight of Silence</em> and <em class="italic">These Things Hidden</em></p>
<p class="noindent">“A page-turner of a thriller with a truly unique and fascinating heroine. I found myself rooting for Dorrie White as she was forced to confront not only a brutal killer but the dark secrets of her past.”</p>
<p class="right">—Alison Gaylin, national bestselling author of <em class="italic">And She Was</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm.vue?edc153b6